/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Stock_AvailabilityInputs */

const en_nav_stock_availability = /** @type {(inputs: Nav_Stock_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Availability`)
};

/**
* | output |
* | --- |
* | "Availability" |
*
* @param {Nav_Stock_AvailabilityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_stock_availability = /** @type {((inputs?: Nav_Stock_AvailabilityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Stock_AvailabilityInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_stock_availability(inputs)
});